import client from "@/libs/client.ts";
import type { Reservations } from "@/types/reservation";
import type { DateRange } from "@/types/date";

const fetchReservations = async (dateRange: DateRange): Promise<Reservations> => {
  const response = await client.get(
    `account/reservations?from=${dateRange.from.format("YYYY-MM-DD")}&to=${dateRange.to.format("YYYY-MM-DD")}`,
  );

  return response.data.data;
};

export { fetchReservations };
